// **************************
// MAIN ACTIVITY
// **************************

export const getMainActivityList = (language) => {
    switch (language) {
        case 'pt':
            return MAIN_ACTIVITY_LIST;
        break;
        case 'en':
            return EN_MAIN_ACTIVITY_LIST;
        break;
        case 'es':
            return ES_MAIN_ACTIVITY_LIST;
        break;
        case 'fr':
            return FR_MAIN_ACTIVITY_LIST;
        break;
        default:
            break;
    }
}

export const getTranslatedMainActivityOption = (value, language) => {
    switch (language) {
        case 'pt':
            for (let i = 0; i < MAIN_ACTIVITY_LIST.length; i++) {
                if(MAIN_ACTIVITY_LIST[i].code === value) {
                    return { code: value, name: MAIN_ACTIVITY_LIST[i].name };
                }
            }
        break;
        case 'en':
            for (let i = 0; i < EN_MAIN_ACTIVITY_LIST.length; i++) {
                if(EN_MAIN_ACTIVITY_LIST[i].code === value) {
                    return { code: value, name: EN_MAIN_ACTIVITY_LIST[i].name };
                }
            }
        break;
        case 'es':
            for (let i = 0; i < ES_MAIN_ACTIVITY_LIST.length; i++) {
                if(ES_MAIN_ACTIVITY_LIST[i].code === value) {
                    return { code: value, name: ES_MAIN_ACTIVITY_LIST[i].name };
                }
            }
        break;
        case 'fr':
            for (let i = 0; i < FR_MAIN_ACTIVITY_LIST.length; i++) {
                if(FR_MAIN_ACTIVITY_LIST[i].code === value) {
                    return { code: value, name: FR_MAIN_ACTIVITY_LIST[i].name };
                }
            }
        break;
        default:
            break;
    }
}

export const MAIN_ACTIVITY_LIST = [
    { code: "Público", name: "Público" },
    { code: "Privado", name: "Privado" },
    { code: "Social", name: "Social" },
    { code: "Desempregado", name: "Desempregado" },
    { code: "Inativo", name: "Inativo" },
    { code: "Reformado", name: "Reformado" }
];

export const EN_MAIN_ACTIVITY_LIST = [
    { code: "Público", name: "Civil" },
    { code: "Privado", name: "Private" },
    { code: "Social", name: "Social" },
    { code: "Desempregado", name: "Unemployed" },
    { code: "Inativo", name: "Inactive" },
    { code: "Reformado", name: "Retired" }
];

export const ES_MAIN_ACTIVITY_LIST = [
    { code: "Público", name: "Público" },
    { code: "Privado", name: "Privado" },
    { code: "Social", name: "Social" },
    { code: "Desempregado", name: "Desempleado" },
    { code: "Inativo", name: "Inactivo" },
    { code: "Reformado", name: "Retirado" }
];

export const FR_MAIN_ACTIVITY_LIST = [
    { code: "Público", name: "Public" },
    { code: "Privado", name: "Privé" },
    { code: "Social", name: "Social" },
    { code: "Desempregado", name: "Chômeur" },
    { code: "Inativo", name: "Inactif" },
    { code: "Reformado", name: "Retraité" }
];


// **************************
// MAIN ACTIVITY CONTRACT
// **************************

export const getMainActivityContractList = (language) => {
    switch (language) {
        case 'pt':
            return MAIN_ACTIVITY_CONTRACT;
        break;
        case 'en':
            return EN_MAIN_ACTIVITY_CONTRACT;
        break;
        case 'es':
            return ES_MAIN_ACTIVITY_CONTRACT;
        break;
        case 'fr':
            return FR_MAIN_ACTIVITY_CONTRACT;
        break;
        default:
            break;
    }
}

export const getTranslatedMainActivityContractOption = (value, language) => {
    switch (language) {
        case 'pt':
            for (let i = 0; i < MAIN_ACTIVITY_CONTRACT.length; i++) {
                if(MAIN_ACTIVITY_CONTRACT[i].code === value) {
                    return { code: value, name: MAIN_ACTIVITY_CONTRACT[i].name };
                }
            }
        break;
        case 'en':
            for (let i = 0; i < EN_MAIN_ACTIVITY_CONTRACT.length; i++) {
                if(EN_MAIN_ACTIVITY_CONTRACT[i].code === value) {
                    return { code: value, name: EN_MAIN_ACTIVITY_CONTRACT[i].name };
                }
            }
        break;
        case 'es':
            for (let i = 0; i < ES_MAIN_ACTIVITY_CONTRACT.length; i++) {
                if(ES_MAIN_ACTIVITY_CONTRACT[i].code === value) {
                    return { code: value, name: ES_MAIN_ACTIVITY_CONTRACT[i].name };
                }
            }
        break;
        case 'fr':
            for (let i = 0; i < FR_MAIN_ACTIVITY_CONTRACT.length; i++) {
                if(FR_MAIN_ACTIVITY_CONTRACT[i].code === value) {
                    return { code: value, name: FR_MAIN_ACTIVITY_CONTRACT[i].name };
                }
            }
        break;
        default:
            break;
    }
}

export const MAIN_ACTIVITY_CONTRACT = [
    { code: "- Exercício liberal / conta própria", name: "- Exercício liberal / conta própria" },
    { code: "- Função pública", name: "- Função pública" },
    { code: "- A trabalhar por conta de outrem com contrato a termo indeterminado", name: "- A trabalhar por conta de outrem com contrato a termo indeterminado" },
    { code: "- A trabalhar por conta de outrem com contrato a termo certo / incerto", name: "- A trabalhar por conta de outrem com contrato a termo certo / incerto" },
    { code: "- Recibos verdes", name: "- Recibos verdes" },
    { code: "- Desempregado (à procura de emprego)", name: "- Desempregado (à procura de emprego)" },
    { code: "- Inativo (não exerce a profissão no momento atual)", name: "- Inativo (não exerce a profissão no momento atual)" },
    { code: "- Reformado", name: "- Reformado" }
];

export const EN_MAIN_ACTIVITY_CONTRACT = [
    { code: "- Exercício liberal / conta própria", name: "- Independent exercise / Self-employed" },
    { code: "- Função pública", name: "- Civil service" },
    { code: "- A trabalhar por conta de outrem com contrato a termo indeterminado", name: "- Working as an employee under an open-ended contract" },
    { code: "- A trabalhar por conta de outrem com contrato a termo certo / incerto", name: "- Working as an employee under a fixed-term / unfixed-term contract" },
    { code: "- Recibos verdes", name: "- Green receipts" },
    { code: "- Desempregado (à procura de emprego)", name: "- Unemployed (seeking employment)" },
    { code: "- Inativo (não exerce a profissão no momento atual)", name: "- Inactive (does not perform the profession at the current moment)" },
    { code: "- Reformado", name: "- Retired" }
];

export const ES_MAIN_ACTIVITY_CONTRACT = [
    { code: "- Exercício liberal / conta própria", name: "- - Ejercicio liberal / trabajo por cuenta propia" },
    { code: "- Função pública", name: "- Función Pública" },
    { code: "- A trabalhar por conta de outrem com contrato a termo indeterminado", name: "- Trabajando por cuenta ajena con un contrato de duración indeterminada" },
    { code: "- A trabalhar por conta de outrem com contrato a termo certo / incerto", name: "- - Trabajando por cuenta ajena con un contrato de duración definida / indefinida" },
    { code: "- Recibos verdes", name: "- Recibos verdes" },
    { code: "- Desempregado (à procura de emprego)", name: "- Desempleado (buscando trabajo)" },
    { code: "- Inativo (não exerce a profissão no momento atual)", name: "- Inactivo (no trabaja en el momento actual)" },
    { code: "- Reformado", name: "- Retirado" }
];


export const FR_MAIN_ACTIVITY_CONTRACT = [
    { code: "- Exercício liberal / conta própria", name: "- Exercice libéral / indépendant" },
    { code: "- Função pública", name: "- Fonction publique" },
    { code: "- A trabalhar por conta de outrem com contrato a termo indeterminado", name: "- Employé avec un contrat permanent" },
    { code: "- A trabalhar por conta de outrem com contrato a termo certo / incerto", name: "- Employé avec un contrat à durée déterminée/indéterminée" },
    { code: "- Recibos verdes", name: "- Reçus verts" },
    { code: "- Desempregado (à procura de emprego)", name: "- Chômeur (à la recherche d'un emploi)" },
    { code: "- Inativo (não exerce a profissão no momento atual)", name: "- Inactif (n'exerce pas actuellement la profession)" },
    { code: "- Reformado", name: "- Retraité" }
];


// **************************
// MAIN ACTIVITY CONTEXT
// **************************

export const getMainActivityContextList = (language) => {
    switch (language) {
        case 'pt':
            return MAIN_ACTIVITY_CONTEXT;
        break;
        case 'en':
            return EN_MAIN_ACTIVITY_CONTEXT;
        break;
        case 'es':
            return ES_MAIN_ACTIVITY_CONTEXT;
        break;
        case 'fr':
            return FR_MAIN_ACTIVITY_CONTEXT;
        break;
        default:
            break;
    }
}

export const getTranslatedMainActivityContextOption = (value, language) => {
    switch (language) {
        case 'pt':
            for (let i = 0; i < MAIN_ACTIVITY_CONTEXT.length; i++) {
                if(MAIN_ACTIVITY_CONTEXT[i].code === value) {
                    return { code: value, name: MAIN_ACTIVITY_CONTEXT[i].name };
                }
            }
        break;
        case 'en':
            for (let i = 0; i < EN_MAIN_ACTIVITY_CONTEXT.length; i++) {
                if(EN_MAIN_ACTIVITY_CONTEXT[i].code === value) {
                    return { code: value, name: EN_MAIN_ACTIVITY_CONTEXT[i].name };
                }
            }
        break;
        case 'es':
            for (let i = 0; i < ES_MAIN_ACTIVITY_CONTEXT.length; i++) {
                if(ES_MAIN_ACTIVITY_CONTEXT[i].code === value) {
                    return { code: value, name: ES_MAIN_ACTIVITY_CONTEXT[i].name };
                }
            }
        break;
        case 'fr':
            for (let i = 0; i < FR_MAIN_ACTIVITY_CONTEXT.length; i++) {
                if(FR_MAIN_ACTIVITY_CONTEXT[i].code === value) {
                    return { code: value, name: FR_MAIN_ACTIVITY_CONTEXT[i].name };
                }
            }
        break;
        default:
            break;
    }
}

export const MAIN_ACTIVITY_CONTEXT = [
    { code: "- Agrupamentos de Centros de Saúde (ACES)", name: "- Agrupamentos de Centros de Saúde (ACES)" },
    { code: "- Hospitais", name: "- Hospitais" },
    { code: "- Unidade de Cuidados Continuados", name: "- Unidade de Cuidados Continuados" },
    { code: "- Unidades de Cuidados Paliativos", name: "- Unidades de Cuidados Paliativos" },
    { code: "- Centros de Reabilitação", name: "- Centros de Reabilitação" },
    { code: "- Clínica de Medicina Física e Reabilitação (sem internamento)", name: "- Clínica de Medicina Física e Reabilitação (sem internamento)" },
    { code: "- Unidades Privadas de Fisioterapia (gabinetes)", name: "- Unidades Privadas de Fisioterapia (gabinetes)" },
    { code: "- Domicílio (a título individual)", name: "- Domicílio (a título individual)" },
    { code: "- Domicílio (a título organizacional)", name: "- Domicílio (a título organizacional)" },
    { code: "- ERPI__Estruturas Residenciais para idosos, ou instituições de apoio a pessoas dependentes (exemplo: APPACDM, centro de paralisia cerebral, lar de idosos, centro de dia, entre outros)", name: "- ERPI__Estruturas Residenciais para idosos, ou instituições de apoio a pessoas dependentes (exemplo: APPACDM, centro de paralisia cerebral, lar de idosos, centro de dia, entre outros)" },
    { code: "- Organizações desportivas (exemplo: Clubes desportivos, Federações de Desportos específicos, Comité Olímpico, entre outros)", name: "- Organizações desportivas (exemplo: Clubes desportivos, Federações de Desportos específicos, Comité Olímpico, entre outros)" },
    { code: "- Agrupamentos escolares", name: "- Agrupamentos escolares" },
    { code: "- Autarquias", name: "- Autarquias" },
    { code: "- Estâncias Termais/ Piscinas/ SPA/ Hoteis", name: "- Estâncias Termais/ Piscinas/ SPA/ Hoteis" },
    { code: "- Empresas", name: "- Empresas" },
    { code: "- Organizações não governamentais (exemplos: AMI, Fundações, entre outros)", name: "- Organizações não governamentais (exemplos: AMI, Fundações, entre outros)" },
    { code: "- Instituições de ensino superior (docente)", name: "- Instituições de ensino superior (docente)" },
    { code: "- Centros de Investigação (investigador / bolseiro)", name: "- Centros de Investigação (investigador / bolseiro)" },
    { code: "- Empresas de formação", name: "- Empresas de formação" },
    { code: "- Ministérios e/ou respetivos organismos (exemplo: DGS, entre outros)", name: "- Ministérios e/ou respetivos organismos (exemplo: DGS, entre outros)" },
    { code: "- Tele-fisioterapia /Tele-reabilitação/Tele-saúde /", name: "- Tele-fisioterapia /Tele-reabilitação/Tele-saúde /" },
    { code: "- Atividade voluntária / bro bono ( Associações Profissionais/sindicato/ordem)", name: "- Atividade voluntária / bro bono ( Associações Profissionais/sindicato/ordem)" },
    { code: "- Outras", name: "- Outras" }
];

export const EN_MAIN_ACTIVITY_CONTEXT = [
    { code: "- Agrupamentos de Centros de Saúde (ACES)", name: "- Health Centre Groupings (ACES)" },
    { code: "- Hospitais", name: "- Hospitals" },
    { code: "- Unidade de Cuidados Continuados", name: "- Long-term Care Unit" },
    { code: "- Unidades de Cuidados Paliativos", name: "- Palliative Care Units" },
    { code: "- Centros de Reabilitação", name: "- Rehabilitation Centres" },
    { code: "- Clínica de Medicina Física e Reabilitação (sem internamento)", name: "- Physical Medicine and Rehabilitation Clinic (outpatient)" },
    { code: "- Unidades Privadas de Fisioterapia (gabinetes)", name: "- Private Physiotherapy Units (offices)" },
    { code: "- Domicílio (a título individual)", name: "- Domicile (on an individual basis)" },
    { code: "- Domicílio (a título organizacional)", name: "- Domicile (on an organisational basis)" },
    { code: "- ERPI__Estruturas Residenciais para idosos, ou instituições de apoio a pessoas dependentes (exemplo: APPACDM, centro de paralisia cerebral, lar de idosos, centro de dia, entre outros)", name: "- ERPI__Residential structures for the elderly, or institutions supporting dependent people (e.g. APPACDM, cerebral palsy centre, retirement home, day centre, among others)" },
    { code: "- Organizações desportivas (exemplo: Clubes desportivos, Federações de Desportos específicos, Comité Olímpico, entre outros)", name: "- Sports organisations (e.g. sports clubs, sport-specific federations, Olympic Committee, among others)" },
    { code: "- Agrupamentos escolares", name: "- School groupings" },
    { code: "- Autarquias", name: "- Municipalities" },
    { code: "- Estâncias Termais/ Piscinas/ SPA/ Hoteis", name: "- Thermal Stations/ Pools/ SPA/ Hotels" },
    { code: "- Empresas", name: "- Companies" },
    { code: "- Organizações não governamentais (exemplos: AMI, Fundações, entre outros)", name: "- Non-governmental organisations (e.g. AMI, Foundations, among others)" },
    { code: "- Instituições de ensino superior (docente)", name: "- Higher Education Institutions (lecturer)" },
    { code: "- Centros de Investigação (investigador / bolseiro)", name: "- Research Centres (researcher / scholarship holder)" },
    { code: "- Empresas de formação", name: "- Education companies" },
    { code: "- Ministérios e/ou respetivos organismos (exemplo: DGS, entre outros)", name: "- Ministries and/or respective bodies (e.g DGS, among others)" },
    { code: "- Tele-fisioterapia /Tele-reabilitação/Tele-saúde /", name: "- Tele-physiotherapy / Tele-rehabilitation / Tele-health /" },
    { code: "- Atividade voluntária / bro bono ( Associações Profissionais/sindicato/ordem)", name: "- Voluntary activity / pro bono (Professional Associations / Trade Union / Order)" },
    { code: "- Outras", name: "- Other" }
];

export const ES_MAIN_ACTIVITY_CONTEXT = [
    { code: "- Agrupamentos de Centros de Saúde (ACES)", name: "- Agrupaciones de Centros de Salud (ACES)" },
    { code: "- Hospitais", name: "- Hospitales" },
    { code: "- Unidade de Cuidados Continuados", name: "- Unidade de Cuidados Prolongados" },
    { code: "- Unidades de Cuidados Paliativos", name: "- Unidades de Cuidados Paliativos" },
    { code: "- Centros de Reabilitação", name: "- Centros de Rehabilitación" },
    { code: "- Clínica de Medicina Física e Reabilitação (sem internamento)", name: "- Clínicas de Medicina Física y Rehabilitación (ambulatoria)" },
    { code: "- Unidades Privadas de Fisioterapia (gabinetes)", name: "- Unidades Privadas de Fisioterapia (oficinas)" },
    { code: "- Domicílio (a título individual)", name: "- Domicilio (a nivel individual)" },
    { code: "- Domicílio (a título organizacional)", name: "- Domicilio (a nivel organizacional)" },
    { code: "- ERPI__Estruturas Residenciais para idosos, ou instituições de apoio a pessoas dependentes (exemplo: APPACDM, centro de paralisia cerebral, lar de idosos, centro de dia, entre outros)", name: "- ERPI__Estructuras residenciales para personas mayores, o instituciones de apoyo a personas dependientes (por ejemplo: APPACDM, centro de parálisis cerebral, residencia de ancianos, centro de día, entre otros)" },
    { code: "- Organizações desportivas (exemplo: Clubes desportivos, Federações de Desportos específicos, Comité Olímpico, entre outros)", name: "- Organizaciones deportivas (por ejemplo: clubes deportivos, federaciones deportivas específicas, Comité Olímpico, etc.)" },
    { code: "- Agrupamentos escolares", name: "- Grupos escolares" },
    { code: "- Autarquias", name: "- Municipios" },
    { code: "- Estâncias Termais/ Piscinas/ SPA/ Hoteis", name: "- Centros termales / Piscinas / SPA / Hoteles" },
    { code: "- Empresas", name: "- Empresas" },
    { code: "- Organizações não governamentais (exemplos: AMI, Fundações, entre outros)", name: "- Organizaciones no gubernamentales (ejemplos: AMI, Fundaciones, entre otras)" },
    { code: "- Instituições de ensino superior (docente)", name: "- Instituciones de educación superior (profesor)" },
    { code: "- Centros de Investigação (investigador / bolseiro)", name: "- Centros de Investigación (investigador / becario)" },
    { code: "- Empresas de formação", name: "- Empresas de formación" },
    { code: "- Ministérios e/ou respetivos organismos (exemplo: DGS, entre outros)", name: "- Ministerios y/o organismos respectivos (por ejemplo: DGS, entre otros)" },
    { code: "- Tele-fisioterapia /Tele-reabilitação/Tele-saúde /", name: "- Telefisioterapia /Tele-rehabilitación /Tele-salud /" },
    { code: "- Atividade voluntária / bro bono ( Associações Profissionais/sindicato/ordem)", name: "- Actividad voluntaria / pro bono (Asociaciones profesionales/sindicato/orden)" },
    { code: "- Outras", name: "- Otras" }
];

export const FR_MAIN_ACTIVITY_CONTEXT = [
    { code: "- Agrupamentos de Centros de Saúde (ACES)", name: "- Groupements de Centres de Santé (ACES)" },
    { code: "- Hospitais", name: "- Hôpitaux" },
    { code: "- Unidade de Cuidados Continuados", name: "- Unité de Soins Continus" },
    { code: "- Unidades de Cuidados Paliativos", name: "- Unités de Soins Palliatifs" },
    { code: "- Centros de Reabilitação", name: "- Centres de Réhabilitation" },
    { code: "- Clínica de Medicina Física e Reabilitação (sem internamento)", name: "- Clinique de Médecine Physique et Réhabilitation (ambulatoire)" },
    { code: "- Unidades Privadas de Fisioterapia (gabinetes)", name: "- Unités de Physiothérapie Privées (bureaux)" },
    { code: "- Domicílio (a título individual)", name: "- Domicile (à titre individuel)" },
    { code: "- Domicílio (a título organizacional)", name: "- Domicile (à titre organisationnel)" },
    { code: "- ERPI__Estruturas Residenciais para idosos, ou instituições de apoio a pessoas dependentes (exemplo: APPACDM, centro de paralisia cerebral, lar de idosos, centro de dia, entre outros)", name: "- ERPI__Structures Résidentielles pour personnes âgées ou institutions d'aide aux personnes dépendantes (par exemple, APPACDM, centre d'infirmité motrice cérébrale, maison de retraite, centre de jour, etc.)" },
    { code: "- Organizações desportivas (exemplo: Clubes desportivos, Federações de Desportos específicos, Comité Olímpico, entre outros)", name: "- Organisations sportives (par exemple, Clubs sportifs, Fédérations sportives spécifiques, Comité Olympique, etc.)" },
    { code: "- Agrupamentos escolares", name: "- Groupements scolaires" },
    { code: "- Autarquias", name: "- Municipalités" },
    { code: "- Estâncias Termais/ Piscinas/ SPA/ Hoteis", name: "- Stations Thermales / Piscines / SPA / Hôtels" },
    { code: "- Empresas", name: "- Entreprises" },
    { code: "- Organizações não governamentais (exemplos: AMI, Fundações, entre outros)", name: "- Organisations non gouvernementales (exemples AMI, Fondations, entre autres)" },
    { code: "- Instituições de ensino superior (docente)", name: "- Institutions d'enseignement supérieur (enseignant)" },
    { code: "- Centros de Investigação (investigador / bolseiro)", name: "- Centres de Recherche (chercheur / boursier)" },
    { code: "- Empresas de formação", name: "- Entreprises de formation" },
    { code: "- Ministérios e/ou respetivos organismos (exemplo: DGS, entre outros)", name: "- Ministères et/ou organismes respectifs (exemple: DGS, entre autres)" },
    { code: "- Tele-fisioterapia /Tele-reabilitação/Tele-saúde /", name: "- Télé-physiothérapie / Télé-réhabilitation / Télé-santé /" },
    { code: "- Atividade voluntária / bro bono ( Associações Profissionais/sindicato/ordem)", name: "- Activité bénévole / pro bono (Associations Professionnelles/syndicat/ordre)" },
    { code: "- Outras", name: "- Autres" }
];


// **************************
// SECONDARY ACTIVITY CONTEXT
// **************************

export const SECONDARY_ACTIVITY_CONTEXT = [
    { code: "- Agrupamentos de Centros de Saúde (ACES)", name: "- Agrupamentos de Centros de Saúde (ACES)" },
    { code: "- Hospitais", name: "- Hospitais" },
    { code: "- Unidade de Cuidados Continuados", name: "- Unidade de Cuidados Continuados" },
    { code: "- Unidades de Cuidados Paliativos", name: "- Unidades de Cuidados Paliativos" },
    { code: "- Centros de Reabilitação", name: "- Centros de Reabilitação" },
    { code: "- Clínica de Medicina Física e Reabilitação (sem internamento)", name: "- Clínica de Medicina Física e Reabilitação (sem internamento)" },
    { code: "- Unidades Privadas de Fisioterapia (gabinetes)", name: "- Unidades Privadas de Fisioterapia (gabinetes)" },
    { code: "- Domicílio (a título individual)", name: "- Domicílio (a título individual)" },
    { code: "- Domicílio (a título organizacional)", name: "- Domicílio (a título organizacional)" },
    { code: "- ERPI__Estruturas Residenciais para idosos, ou instituições de apoio a pessoas dependentes (exemplo: APPACDM, centro de paralisia cerebral, lar de idosos, centro de dia, entre outros)", name: "- ERPI__Estruturas Residenciais para idosos, ou instituições de apoio a pessoas dependentes (exemplo: APPACDM, centro de paralisia cerebral, lar de idosos, centro de dia, entre outros)" },
    { code: "- Organizações desportivas (exemplo: Clubes desportivos, Federações de Desportos específicos, Comité Olímpico, entre outros)", name: "- Organizações desportivas (exemplo: Clubes desportivos, Federações de Desportos específicos, Comité Olímpico, entre outros)" },
    { code: "- Agrupamentos escolares", name: "- Agrupamentos escolares" },
    { code: "- Autarquias", name: "- Autarquias" },
    { code: "- Estâncias Termais/ Piscinas/ SPA/ Hoteis", name: "- Estâncias Termais/ Piscinas/ SPA/ Hoteis" },
    { code: "- Empresas", name: "- Empresas" },
    { code: "- Organizações não governamentais (exemplos: AMI, Fundações, entre outros)", name: "- Organizações não governamentais (exemplos: AMI, Fundações, entre outros)" },
    { code: "- Instituições de ensino superior (docente)", name: "- Instituições de ensino superior (docente)" },
    { code: "- Centros de Investigação (investigador / bolseiro)", name: "- Centros de Investigação (investigador / bolseiro)" },
    { code: "- Empresas de formação", name: "- Empresas de formação" },
    { code: "- Ministérios e/ou respetivos organismos (exemplo: DGS, entre outros)", name: "- Ministérios e/ou respetivos organismos (exemplo: DGS, entre outros)" },
    { code: "- Tele-fisioterapia /Tele-reabilitação/Tele-saúde /", name: "- Tele-fisioterapia /Tele-reabilitação/Tele-saúde /" },
    { code: "- Atividade voluntária / bro bono ( Associações Profissionais/sindicato/ordem)", name: "- Atividade voluntária / bro bono ( Associações Profissionais/sindicato/ordem)" },
    { code: "- Outras", name: "- Outras" }
];

export const EN_SECONDARY_ACTIVITY_CONTEXT = [
    { code: "- Agrupamentos de Centros de Saúde (ACES)", name: "- Health Centre Groupings (ACES)" },
    { code: "- Hospitais", name: "- Hospitals" },
    { code: "- Unidade de Cuidados Continuados", name: "- Long-term Care Unit" },
    { code: "- Unidades de Cuidados Paliativos", name: "- Palliative Care Units" },
    { code: "- Centros de Reabilitação", name: "- Rehabilitation Centres" },
    { code: "- Clínica de Medicina Física e Reabilitação (sem internamento)", name: "- Physical Medicine and Rehabilitation Clinic (outpatient)" },
    { code: "- Unidades Privadas de Fisioterapia (gabinetes)", name: "- Private Physiotherapy Units (offices)" },
    { code: "- Domicílio (a título individual)", name: "- Domicile (on an individual basis)" },
    { code: "- Domicílio (a título organizacional)", name: "- Domicile (on an organisational basis)" },
    { code: "- ERPI__Estruturas Residenciais para idosos, ou instituições de apoio a pessoas dependentes (exemplo: APPACDM, centro de paralisia cerebral, lar de idosos, centro de dia, entre outros)", name: "- ERPI__Residential structures for the elderly, or institutions supporting dependent people (e.g. APPACDM, cerebral palsy centre, retirement home, day centre, among others)" },
    { code: "- Organizações desportivas (exemplo: Clubes desportivos, Federações de Desportos específicos, Comité Olímpico, entre outros)", name: "- Sports organisations (e.g. sports clubs, sport-specific federations, Olympic Committee, among others)" },
    { code: "- Agrupamentos escolares", name: "- School groupings" },
    { code: "- Autarquias", name: "- Municipalities" },
    { code: "- Estâncias Termais/ Piscinas/ SPA/ Hoteis", name: "- Thermal Stations/ Pools/ SPA/ Hotels" },
    { code: "- Empresas", name: "- Companies" },
    { code: "- Organizações não governamentais (exemplos: AMI, Fundações, entre outros)", name: "- Non-governmental organisations (e.g. AMI, Foundations, among others)" },
    { code: "- Instituições de ensino superior (docente)", name: "- Higher Education Institutions (lecturer)" },
    { code: "- Centros de Investigação (investigador / bolseiro)", name: "- Research Centres (researcher / scholarship holder)" },
    { code: "- Empresas de formação", name: "- Education companies" },
    { code: "- Ministérios e/ou respetivos organismos (exemplo: DGS, entre outros)", name: "- Ministries and/or respective bodies (e.g DGS, among others)" },
    { code: "- Tele-fisioterapia /Tele-reabilitação/Tele-saúde /", name: "- Tele-physiotherapy / Tele-rehabilitation / Tele-health /" },
    { code: "- Atividade voluntária / bro bono ( Associações Profissionais/sindicato/ordem)", name: "- Voluntary activity / pro bono (Professional Associations / Trade Union / Order)" },
    { code: "- Outras", name: "- Other" }
];

export const ES_SECONDARY_ACTIVITY_CONTEXT = [
    { code: "- Agrupamentos de Centros de Saúde (ACES)", name: "- Agrupaciones de Centros de Salud (ACES)" },
    { code: "- Hospitais", name: "- Hospitales" },
    { code: "- Unidade de Cuidados Continuados", name: "- Unidade de Cuidados Prolongados" },
    { code: "- Unidades de Cuidados Paliativos", name: "- Unidades de Cuidados Paliativos" },
    { code: "- Centros de Reabilitação", name: "- Centros de Rehabilitación" },
    { code: "- Clínica de Medicina Física e Reabilitação (sem internamento)", name: "- Clínicas de Medicina Física y Rehabilitación (ambulatoria)" },
    { code: "- Unidades Privadas de Fisioterapia (gabinetes)", name: "- Unidades Privadas de Fisioterapia (oficinas)" },
    { code: "- Domicílio (a título individual)", name: "- Domicilio (a nivel individual)" },
    { code: "- Domicílio (a título organizacional)", name: "- Domicilio (a nivel organizacional)" },
    { code: "- ERPI__Estruturas Residenciais para idosos, ou instituições de apoio a pessoas dependentes (exemplo: APPACDM, centro de paralisia cerebral, lar de idosos, centro de dia, entre outros)", name: "- ERPI__Estructuras residenciales para personas mayores, o instituciones de apoyo a personas dependientes (por ejemplo: APPACDM, centro de parálisis cerebral, residencia de ancianos, centro de día, entre otros)" },
    { code: "- Organizações desportivas (exemplo: Clubes desportivos, Federações de Desportos específicos, Comité Olímpico, entre outros)", name: "- Organizaciones deportivas (por ejemplo: clubes deportivos, federaciones deportivas específicas, Comité Olímpico, etc.)" },
    { code: "- Agrupamentos escolares", name: "- Grupos escolares" },
    { code: "- Autarquias", name: "- Municipios" },
    { code: "- Estâncias Termais/ Piscinas/ SPA/ Hoteis", name: "- Centros termales / Piscinas / SPA / Hoteles" },
    { code: "- Empresas", name: "- Empresas" },
    { code: "- Organizações não governamentais (exemplos: AMI, Fundações, entre outros)", name: "- Organizaciones no gubernamentales (ejemplos: AMI, Fundaciones, entre otras)" },
    { code: "- Instituições de ensino superior (docente)", name: "- Instituciones de educación superior (profesor)" },
    { code: "- Centros de Investigação (investigador / bolseiro)", name: "- Centros de Investigación (investigador / becario)" },
    { code: "- Empresas de formação", name: "- Empresas de formación" },
    { code: "- Ministérios e/ou respetivos organismos (exemplo: DGS, entre outros)", name: "- Ministerios y/o organismos respectivos (por ejemplo: DGS, entre otros)" },
    { code: "- Tele-fisioterapia /Tele-reabilitação/Tele-saúde /", name: "- Telefisioterapia /Tele-rehabilitación /Tele-salud /" },
    { code: "- Atividade voluntária / bro bono ( Associações Profissionais/sindicato/ordem)", name: "- Actividad voluntaria / pro bono (Asociaciones profesionales/sindicato/orden)" },
    { code: "- Outras", name: "- Otras" }
];

export const FR_SECONDARY_ACTIVITY_CONTEXT = [
    { code: "- Agrupamentos de Centros de Saúde (ACES)", name: "- Groupements de Centres de Santé (ACES)" },
    { code: "- Hospitais", name: "- Hôpitaux" },
    { code: "- Unidade de Cuidados Continuados", name: "- Unité de Soins Continus" },
    { code: "- Unidades de Cuidados Paliativos", name: "- Unités de Soins Palliatifs" },
    { code: "- Centros de Reabilitação", name: "- Centres de Réhabilitation" },
    { code: "- Clínica de Medicina Física e Reabilitação (sem internamento)", name: "- Clinique de Médecine Physique et Réhabilitation (ambulatoire)" },
    { code: "- Unidades Privadas de Fisioterapia (gabinetes)", name: "- Unités de Physiothérapie Privées (bureaux)" },
    { code: "- Domicílio (a título individual)", name: "- Domicile (à titre individuel)" },
    { code: "- Domicílio (a título organizacional)", name: "- Domicile (à titre organisationnel)" },
    { code: "- ERPI__Estruturas Residenciais para idosos, ou instituições de apoio a pessoas dependentes (exemplo: APPACDM, centro de paralisia cerebral, lar de idosos, centro de dia, entre outros)", name: "- ERPI__Structures Résidentielles pour personnes âgées ou institutions d'aide aux personnes dépendantes (par exemple, APPACDM, centre d'infirmité motrice cérébrale, maison de retraite, centre de jour, etc.)" },
    { code: "- Organizações desportivas (exemplo: Clubes desportivos, Federações de Desportos específicos, Comité Olímpico, entre outros)", name: "- Organisations sportives (par exemple, Clubs sportifs, Fédérations sportives spécifiques, Comité Olympique, etc.)" },
    { code: "- Agrupamentos escolares", name: "- Groupements scolaires" },
    { code: "- Autarquias", name: "- Municipalités" },
    { code: "- Estâncias Termais/ Piscinas/ SPA/ Hoteis", name: "- Stations Thermales / Piscines / SPA / Hôtels" },
    { code: "- Empresas", name: "- Entreprises" },
    { code: "- Organizações não governamentais (exemplos: AMI, Fundações, entre outros)", name: "- Organisations non gouvernementales (exemples AMI, Fondations, entre autres)" },
    { code: "- Instituições de ensino superior (docente)", name: "- Institutions d'enseignement supérieur (enseignant)" },
    { code: "- Centros de Investigação (investigador / bolseiro)", name: "- Centres de Recherche (chercheur / boursier)" },
    { code: "- Empresas de formação", name: "- Entreprises de formation" },
    { code: "- Ministérios e/ou respetivos organismos (exemplo: DGS, entre outros)", name: "- Ministères et/ou organismes respectifs (exemple: DGS, entre autres)" },
    { code: "- Tele-fisioterapia /Tele-reabilitação/Tele-saúde /", name: "- Télé-physiothérapie / Télé-réhabilitation / Télé-santé /" },
    { code: "- Atividade voluntária / bro bono ( Associações Profissionais/sindicato/ordem)", name: "- Activité bénévole / pro bono (Associations Professionnelles/syndicat/ordre)" },
    { code: "- Outras", name: "- Autres" }
];

// **************************
// NUM WORKPLACES
// **************************

export const getNumWorkspacesList = (language) => {
    switch (language) {
        case 'pt':
            return NUM_WORLPLACES_LIST;
        break;
        case 'en':
            return EN_NUM_WORLPLACES_LIST;
        break;
        case 'es':
            return ES_NUM_WORLPLACES_LIST;
        break;
        case 'fr':
            return FR_NUM_WORLPLACES_LIST;
        break;
        default:
            break;
    }
}

export const getTranslatedNumWorkplacesOption = (value, language) => {
    switch (language) {
        case 'pt':
            for (let i = 0; i < NUM_WORLPLACES_LIST.length; i++) {
                if(NUM_WORLPLACES_LIST[i].code === value) {
                    return { code: value, name: NUM_WORLPLACES_LIST[i].name };
                }
            }
        break;
        case 'en':
            for (let i = 0; i < EN_NUM_WORLPLACES_LIST.length; i++) {
                if(EN_NUM_WORLPLACES_LIST[i].code === value) {
                    return { code: value, name: EN_NUM_WORLPLACES_LIST[i].name };
                }
            }
        break;
        case 'es':
            for (let i = 0; i < ES_NUM_WORLPLACES_LIST.length; i++) {
                if(ES_NUM_WORLPLACES_LIST[i].code === value) {
                    return { code: value, name: ES_NUM_WORLPLACES_LIST[i].name };
                }
            }
        break;
        case 'fr':
            for (let i = 0; i < FR_NUM_WORLPLACES_LIST.length; i++) {
                if(FR_NUM_WORLPLACES_LIST[i].code === value) {
                    return { code: value, name: FR_NUM_WORLPLACES_LIST[i].name };
                }
            }
        break;
        default:
            break;
    }
}

export const NUM_WORLPLACES_LIST = [
    { code: "- Apenas num local", name: "- Apenas num local" },
    { code: "- Em dois locais", name: "- Em dois locais" },
    { code: "- Em três locais", name: "- Em três locais" },
    { code: "- Em mais de três locais", name: "- Em mais de três locais" }
];

export const EN_NUM_WORLPLACES_LIST = [
    { code: "- Apenas num local", name: "- Only in one workplace" },
    { code: "- Em dois locais", name: "- In two workplaces" },
    { code: "- Em três locais", name: "- In three workplaces" },
    { code: "- Em mais de três locais", name: "- In more than three workplaces" }
];

export const ES_NUM_WORLPLACES_LIST = [
    { code: "- Apenas num local", name: "- En un solo lugar" },
    { code: "- Em dois locais", name: "- En dos lugares" },
    { code: "- Em três locais", name: "- En tres lugares" },
    { code: "- Em mais de três locais", name: "- En más de tres lugares" }
];

export const FR_NUM_WORLPLACES_LIST = [
    { code: "- Apenas num local", name: "- Seulement dans un endroit" },
    { code: "- Em dois locais", name: "- Dans deux endroits" },
    { code: "- Em três locais", name: "- Dans trois endroits" },
    { code: "- Em mais de três locais", name: "- Dans plus de trois endroits" }
];

// **************************
// NUM HOURS
// **************************

export const getNumHoursList = (language) => {
    switch (language) {
        case 'pt':
            return NUM_HOURS_LIST;
        break;
        case 'en':
            return EN_NUM_HOURS_LIST;
        break;
        case 'es':
            return ES_NUM_HOURS_LIST;
        break;
        case 'fr':
            return FR_NUM_HOURS_LIST;
        break;
        default:
            break;
    }
}

export const getTranslatedNumHoursOption = (value, language) => {
    switch (language) {
        case 'pt':
            for (let i = 0; i < NUM_HOURS_LIST.length; i++) {
                if(NUM_HOURS_LIST[i].code === value) {
                    return { code: value, name: NUM_HOURS_LIST[i].name };
                }
            }
        break;
        case 'en':
            for (let i = 0; i < EN_NUM_HOURS_LIST.length; i++) {
                if(EN_NUM_HOURS_LIST[i].code === value) {
                    return { code: value, name: EN_NUM_HOURS_LIST[i].name };
                }
            }
        break;
        case 'es':
            for (let i = 0; i < ES_NUM_HOURS_LIST.length; i++) {
                if(ES_NUM_HOURS_LIST[i].code === value) {
                    return { code: value, name: ES_NUM_HOURS_LIST[i].name };
                }
            }
        break;
        case 'fr':
            for (let i = 0; i < FR_NUM_HOURS_LIST.length; i++) {
                if(FR_NUM_HOURS_LIST[i].code === value) {
                    return { code: value, name: FR_NUM_HOURS_LIST[i].name };
                }
            }
        break;
        default:
            break;
    }
}

export const NUM_HOURS_LIST = [
    { code: "Menos de 20h", name: "Menos de 20h" },
    { code: "Entre 21 e 35h", name: "Entre 21 e 35h" },
    { code: "Entre 36 e 40h", name: "Entre 36 e 40h" },
    { code: "Entre 41 e 50h", name: "Entre 41 e 50h" },
    { code: "Mais de 50h", name: "Mais de 50h" }
];

export const EN_NUM_HOURS_LIST = [
    { code: "Menos de 20h", name: "Less than 20h" },
    { code: "Entre 21 e 35h", name: "Between 21 and 35h" },
    { code: "Entre 36 e 40h", name: "Between 36 and 40h" },
    { code: "Entre 41 e 50h", name: "Between 41 and 50h" },
    { code: "Mais de 50h", name: "More than 50h" }
];

export const ES_NUM_HOURS_LIST = [
    { code: "Menos de 20h", name: "Menos de 20h" },
    { code: "Entre 21 e 35h", name: "Entre 21 y 35h" },
    { code: "Entre 36 e 40h", name: "Entre 36 y 40h" },
    { code: "Entre 41 e 50h", name: "Entre 41 y 50h" },
    { code: "Mais de 50h", name: "Más de 50h" }
];

export const FR_NUM_HOURS_LIST = [
    { code: "Menos de 20h", name: "Moins de 20h" },
    { code: "Entre 21 e 35h", name: "Entre 21 et 35h" },
    { code: "Entre 36 e 40h", name: "Entre 36 et 40h" },
    { code: "Entre 41 e 50h", name: "Entre 41 et 50h" },
    { code: "Mais de 50h", name: "Plus de 50h" }
];

// **************************
// TYPE WORK
// **************************

export const getTypeWorkList = (language) => {
    switch (language) {
        case 'pt':
            return TYPE_WORK_LIST;
        break;
        case 'en':
            return EN_TYPE_WORK_LIST;
        break;
        case 'es':
            return ES_TYPE_WORK_LIST;
        break;
        case 'fr':
            return FR_TYPE_WORK_LIST;
        break;
        default:
            break;
    }
}

export const getTranslatedTypeWorkOption = (value, language) => {
    switch (language) {
        case 'pt':
            for (let i = 0; i < TYPE_WORK_LIST.length; i++) {
                if(TYPE_WORK_LIST[i].code === value) {
                    return { code: value, name: TYPE_WORK_LIST[i].name };
                }
            }
        break;
        case 'en':
            for (let i = 0; i < EN_TYPE_WORK_LIST.length; i++) {
                if(EN_TYPE_WORK_LIST[i].code === value) {
                    return { code: value, name: EN_TYPE_WORK_LIST[i].name };
                }
            }
        break;
        case 'es':
            for (let i = 0; i < ES_TYPE_WORK_LIST.length; i++) {
                if(ES_TYPE_WORK_LIST[i].code === value) {
                    return { code: value, name: ES_TYPE_WORK_LIST[i].name };
                }
            }
        break;
        case 'fr':
            for (let i = 0; i < FR_TYPE_WORK_LIST.length; i++) {
                if(FR_TYPE_WORK_LIST[i].code === value) {
                    return { code: value, name: FR_TYPE_WORK_LIST[i].name };
                }
            }
        break;
        default:
            break;
    }
}

export const TYPE_WORK_LIST = [
    { code: "- Atividade exclusivamente clínica (prestação de cuidados)", name: "- Atividade exclusivamente clínica (prestação de cuidados)" },
    { code: "- Atividade Clínica (prestação de cuidados) complementada por supervisão/monitoria de estágios em contexto clínico", name: "- Atividade Clínica (prestação de cuidados) complementada por supervisão/monitoria de estágios em contexto clínico" },
    { code: "- Atividade Clínica (prestação de cuidados) complementado pelo exercício da docência a tempo parcial", name: "- Atividade Clínica (prestação de cuidados) complementado pelo exercício da docência a tempo parcial" },
    { code: "- Atividade essencialmente de Gestão /administração de serviços /unidades (independentemente do sector)", name: "- Atividade essencialmente de Gestão /administração de serviços /unidades (independentemente do sector)" },
    { code: "- Atividade essencialmente de Gestão /administração de serviços /unidades (independentemente do sector), complementada por atividade clínica (prestação de cuidados)", name: "- Atividade essencialmente de Gestão /administração de serviços /unidades (independentemente do sector), complementada por atividade clínica (prestação de cuidados)" },
    { code: "- Atividade essencialmente de Gestão /administração de serviços /unidades (independentemente do sector), complementada por docência (na fisioterapia) a tempo parcial", name: "- Atividade essencialmente de Gestão /administração de serviços /unidades (independentemente do sector), complementada por docência (na fisioterapia) a tempo parcial" },
    { code: "- Atividade de Docência a tempo integral com dedicação exclusiva (inclui cargos de gestão em instituições de ensino superior)", name: "- Atividade de Docência a tempo integral com dedicação exclusiva (inclui cargos de gestão em instituições de ensino superior)" },
    { code: "- Atividade de Docência a tempo integral sem exclusividade complementada com atividade clínica (prestação de cuidados)", name: "- Atividade de Docência a tempo integral sem exclusividade complementada com atividade clínica (prestação de cuidados)" },
    { code: "- Atividades de docência a tempo parcial", name: "- Atividades de docência a tempo parcial" },
    { code: "- Atividade de investigação, complementada com atividade clínica (prestação de cuidados)", name: "- Atividade de investigação, complementada com atividade clínica (prestação de cuidados)" },
    { code: "- Atividade de investigação, complementada com atividade de docência", name: "- Atividade de investigação, complementada com atividade de docência" },
    { code: "- Atividade de gestão/Administração de serviços/unidades independentemente do sector complementado por atividade clínica e docência da Fisioterapia a Tempo parcial", name: "- Atividade de gestão/Administração de serviços/unidades independentemente do sector complementado por atividade clínica e docência da Fisioterapia a Tempo parcial" },
    { code: "- Atividade de docência a tempo integral sem exclusividade", name: "- Atividade de docência a tempo integral sem exclusividade" }
];

export const EN_TYPE_WORK_LIST = [
    { code: "- Atividade exclusivamente clínica (prestação de cuidados)", name: "- Exclusively clinical activity (care provision)" },
    { code: "- Atividade Clínica (prestação de cuidados) complementada por supervisão/monitoria de estágios em contexto clínico", name: "- Clinical activity (care provision) complemented by supervision/monitoring of internships in a clinical context" },
    { code: "- Atividade Clínica (prestação de cuidados) complementado pelo exercício da docência a tempo parcial", name: "- Clinical activity (care provision) complemented by part-time teaching" },
    { code: "- Atividade essencialmente de Gestão /administração de serviços /unidades (independentemente do sector)", name: "- Mostly Management activity/administration of services/units (regardless of the sector)" },
    { code: "- Atividade essencialmente de Gestão /administração de serviços /unidades (independentemente do sector), complementada por atividade clínica (prestação de cuidados)", name: "- Mostly Management activity/administration of services/units (regardless of the sector) complemented by clinical activity (care provision)" },
    { code: "- Atividade essencialmente de Gestão /administração de serviços /unidades (independentemente do sector), complementada por docência (na fisioterapia) a tempo parcial", name: "- Mostly Management activity/administration of services/units (regardless of the sector) complemented by part-time teaching (in physiotherapy)" },
    { code: "- Atividade de Docência a tempo integral com dedicação exclusiva (inclui cargos de gestão em instituições de ensino superior)", name: "- Full-time teaching activity with exclusive dedication (includes management positions in higher education institutions)" },
    { code: "- Atividade de Docência a tempo integral sem exclusividade complementada com atividade clínica (prestação de cuidados)", name: "- Full-time non-exclusive teaching activity complemented by clinical activity (care provision)" },
    { code: "- Atividades de docência a tempo parcial", name: "- Part-time teaching activities" },
    { code: "- Atividade de investigação, complementada com atividade clínica (prestação de cuidados)", name: "- Research activity complemented with clinical activity (care provision)" },
    { code: "- Atividade de investigação, complementada com atividade de docência", name: "- Research activity, complemented with teaching activity" },
    { code: "- Atividade de gestão/Administração de serviços/unidades independentemente do sector complementado por atividade clínica e docência da Fisioterapia a Tempo parcial", name: "- Management activity/Administration of services/units regardless of the sector complemented by part-time clinical activity and Physiotherapy teaching" },
    { code: "- Atividade de docência a tempo integral sem exclusividade", name: "- Full-time non-exclusive teaching activity" }
];

export const ES_TYPE_WORK_LIST = [
    { code: "- Atividade exclusivamente clínica (prestação de cuidados)", name: "- Actividad exclusivamente Clínica (prestación de asistencia sanitaria)" },
    { code: "- Atividade Clínica (prestação de cuidados) complementada por supervisão/monitoria de estágios em contexto clínico", name: "- Actividad Clínica (prestación de asistencia sanitaria) complementada con la supervisión/seguimiento de las prácticas en un contexto clínico" },
    { code: "- Atividade Clínica (prestação de cuidados) complementado pelo exercício da docência a tempo parcial", name: "- Actividad Clínica (prestación de asistencia sanitaria) complementada con actividad docente a tiempo parcial" },
    { code: "- Atividade essencialmente de Gestão /administração de serviços /unidades (independentemente do sector)", name: "- Actividad esencialmente de Gestión/Administración de servicios/unidades (independientemente del sector)" },
    { code: "- Atividade essencialmente de Gestão /administração de serviços /unidades (independentemente do sector), complementada por atividade clínica (prestação de cuidados)", name: "- Actividad esencialmente de Gestión/Administración de servicios/unidades (independientemente del sector), complementada con actividad clínica (prestación de asistencia sanitaria)" },
    { code: "- Atividade essencialmente de Gestão /administração de serviços /unidades (independentemente do sector), complementada por docência (na fisioterapia) a tempo parcial", name: "- Actividad esencialmente de Gestión/Administración de servicios/unidades (independientemente del sector), complementada con docencia (en fisioterapia) a tiempo parcial" },
    { code: "- Atividade de Docência a tempo integral com dedicação exclusiva (inclui cargos de gestão em instituições de ensino superior)", name: "- Actividad docente a tiempo completo con dedicación exclusiva (incluye cargos directivos en instituciones de educación superior)" },
    { code: "- Atividade de Docência a tempo integral sem exclusividade complementada com atividade clínica (prestação de cuidados)", name: "- Actividad docente a tiempo completo sin exclusividad, complementada con actividad clínica (prestación de asistencia sanitaria)" },
    { code: "- Atividades de docência a tempo parcial", name: "- Actividad docente a tiempo parcial" },
    { code: "- Atividade de investigação, complementada com atividade clínica (prestação de cuidados)", name: "- Actividad de investigación, complementada con la actividad clínica (prestación de asistencia sanitaria)" },
    { code: "- Atividade de investigação, complementada com atividade de docência", name: "- Actividad de investigación, complementada con actividad docente" },
    { code: "- Atividade de gestão/Administração de serviços/unidades independentemente do sector complementado por atividade clínica e docência da Fisioterapia a Tempo parcial", name: "- Actividad de Gestión/Administración de servicios/unidades (independientemente del sector), complementada con actividad clínica y docencia de Fisioterapia a tiempo parcial" },
    { code: "- Atividade de docência a tempo integral sem exclusividade", name: "- Actividad docente a tiempo completo sin exclusividad" }
];

export const FR_TYPE_WORK_LIST = [
    { code: "- Atividade exclusivamente clínica (prestação de cuidados)", name: "- Activité exclusivement Clinique (prestation de Soins)" },
    { code: "- Atividade Clínica (prestação de cuidados) complementada por supervisão/monitoria de estágios em contexto clínico", name: "- Activité Clinique (prestation de Soins) complétée par la supervision/le suivi de stages en contexte clinique" },
    { code: "- Atividade Clínica (prestação de cuidados) complementado pelo exercício da docência a tempo parcial", name: "- Activité Clinique (prestation de Soins) complétée par l'Exercice de l'enseignement à temps partiel" },
    { code: "- Atividade essencialmente de Gestão /administração de serviços /unidades (independentemente do sector)", name: "- Activité essentiellement de Gestion/Administration de Services/Unités (quel que soit le secteur)" },
    { code: "- Atividade essencialmente de Gestão /administração de serviços /unidades (independentemente do sector), complementada por atividade clínica (prestação de cuidados)", name: "- Activité essentiellement de Gestion/Administration de Services/Unités (quel que soit le secteur) complétée par Activité Clinique (prestation de Soins)" },
    { code: "- Atividade essencialmente de Gestão /administração de serviços /unidades (independentemente do sector), complementada por docência (na fisioterapia) a tempo parcial", name: "- Activité essentiellement de Gestion/Administration de Services/Unités (quel que soit le secteur) complétée par l'enseignement (en Physiothérapie) à temps partiel" },
    { code: "- Atividade de Docência a tempo integral com dedicação exclusiva (inclui cargos de gestão em instituições de ensino superior)", name: "- Activité d'enseignement à temps complet avec dévouement exclusif (comprend les fonctions de Gestion dans les Institutions d'enseignement supérieur)" },
    { code: "- Atividade de Docência a tempo integral sem exclusividade complementada com atividade clínica (prestação de cuidados)", name: "- Activité d'enseignement à temps complet sans exclusivité complétée par une Activité Clinique (prestation de Soins)" },
    { code: "- Atividades de docência a tempo parcial", name: "- Activités d'enseignement à temps partiel" },
    { code: "- Atividade de investigação, complementada com atividade clínica (prestação de cuidados)", name: "- Activité de Recherche complétée par une Activité Clinique (prestation de Soins)" },
    { code: "- Atividade de investigação, complementada com atividade de docência", name: "- Activité de Recherche complétée par une Activité d'enseignement" },
    { code: "- Atividade de gestão/Administração de serviços/unidades independentemente do sector complementado por atividade clínica e docência da Fisioterapia a Tempo parcial", name: "- Activité de Gestion/Administration de Services/Unités (quel que soit le secteur), complétée par une Activité Clinique et Enseignement de la Physiothérapie à temps partiel" },
    { code: "- Atividade de docência a tempo integral sem exclusividade", name: "- Activité d'enseignement à temps complet sans exclusivité" }
];


// **************************
// CLINIC ACTIVITY
// **************************

export const CLINIC_ACTIVITY_LIST = [
    { code: "Bebé e criança", name: "Bebé e criança" },
    { code: "Adolescente", name: "Adolescente" },
    { code: "Adulto", name: "Adulto" },
    { code: "Pessoa Idosa", name: "Pessoa Idosa" },
    { code: "Maioritariamente com pessoas em Situações agudas", name: "Maioritariamente com pessoas em Situações agudas" },
    { code: "Maioritariamente com pessoas em situações crónicas", name: "Maioritariamente com pessoas em situações crónicas" }
];

export const EN_CLINIC_ACTIVITY_LIST = [
    { code: "Bebé e criança", name: "Baby and child" },
    { code: "Adolescente", name: "Teenager" },
    { code: "Adulto", name: "Adult" },
    { code: "Pessoa Idosa", name: "Elderly Person" },
    { code: "Maioritariamente com pessoas em Situações agudas", name: "Mostly with people in acute conditions" },
    { code: "Maioritariamente com pessoas em situações crónicas", name: "Mostly with people in cronic conditions" }
];

export const ES_CLINIC_ACTIVITY_LIST = [
    { code: "Bebé e criança", name: "Bebé y niño" },
    { code: "Adolescente", name: "Adolescente" },
    { code: "Adulto", name: "Adulto" },
    { code: "Pessoa Idosa", name: "Persona Mayor" },
    { code: "Maioritariamente com pessoas em Situações agudas", name: "Sobre todo con personas en situaciones agudas" },
    { code: "Maioritariamente com pessoas em situações crónicas", name: "Sobre todo con personas en situaciones crónicas" }
];

export const FR_CLINIC_ACTIVITY_LIST = [
    { code: "Bebé e criança", name: "Bébé et enfant" },
    { code: "Adolescente", name: "Adolescent" },
    { code: "Adulto", name: "Adulte" },
    { code: "Pessoa Idosa", name: "Personne Âgée" },
    { code: "Maioritariamente com pessoas em Situações agudas", name: "Principalement avec des personnes en situations aiguës" },
    { code: "Maioritariamente com pessoas em situações crónicas", name: "Principalement avec des personnes en situations chroniques" }
];